import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportPolygonAssets } from '@api/exportAssets';

import { IExportPolygonAssetsDTO } from '@interfaces/map/dto/polygonDTO';

import { ESnackbarTypes } from '@enums/common';

import { EXPORT_POLYGONS_ASSETS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateExportPolygonAssets = () => {
	const dispatch = useAppDispatch();

	const {
		mutate: handleExportPolygonAssets,
		isLoading: isLoadingExportPolygonAssets,
	} = useMutation<IExportPolygonAssetsDTO>({
		mutationKey: [EXPORT_POLYGONS_ASSETS],
		mutationFn: exportPolygonAssets,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportStartingSuccess,
				type: ESnackbarTypes.success,
			}));
		},
		refetchOnWindowFocus: false,
	});

	return {
		handleExportPolygonAssets,
		isLoadingExportPolygonAssets,
	};
};
